import React from "react";
import {Form} from "antd";

import DeviceSettingsForm from "./DeviceSettingsForm";
import UnifiedInputForm from "./UnifiedInputForm";
import HeaderFormTypes from "./HeaderForm";
import {SensorSettings, Unit} from "../../../store/branches/sensors/stateTypes";

import classes from "../EditSensorsTypes.module.scss";

// Input 9/10: on IE-Node-1 (device type 0005), groups "2000" (Pulse) and "3000" (CLI)
// are the same 2 physical wires in mutually-exclusive DIP-switch-selected modes — see
// UnifiedInputForm. IE-Node-2 (0006) has no Pulse group at all (10 always-CLI inputs),
// so it keeps rendering every group through the plain DeviceSettingsForm below.
const PULSE_GROUP_ID = "2000";
const CLI_GROUP_ID = "3000";

interface SettingFormProps {
    onSubmit?: (values: any) => void
    onCancel?: () => void
    form?: any
    deviceTitle?: string
    deviceType?: string
    sensorSettings: SensorSettings[]
    units?: Unit[]
}

const EditSensorsSettingsForm: React.FC<SettingFormProps> = ({
                                                                 onSubmit,
                                                                 onCancel,
                                                                 form,
                                                                 deviceTitle,
                                                                 deviceType,
                                                                 units,
                                                                 sensorSettings,
                                                             }) => {
    const pulseGroup = sensorSettings?.find((group) => group.id === PULSE_GROUP_ID);
    const cliGroup = sensorSettings?.find((group) => group.id === CLI_GROUP_ID);
    const hasUnifiedInputs = Boolean(pulseGroup && cliGroup);

    const remainingGroups = hasUnifiedInputs
        ? sensorSettings.filter((group) => group.id !== PULSE_GROUP_ID && group.id !== CLI_GROUP_ID)
        : sensorSettings;

    return (
        <div className={"header-link"}>
            <Form name="edit_sensor_names"
                  form={form}
                  onFinish={onSubmit}
            >

                <HeaderFormTypes onCancel={onCancel}/>

                <div className={classes.sensorsNamesInputsWrap}>
                    <div className={classes.sensorsTitle}>
                        <div className={classes.sensorsSub}>
                            <div/>
                            <div>
                                <span>{deviceTitle}</span>
                            </div>
                        </div>
                    </div>

                    <div className={classes.container}>

                        {
                            hasUnifiedInputs &&
                            <UnifiedInputForm pulseGroup={pulseGroup as SensorSettings}
                                              cliGroup={cliGroup as SensorSettings}
                                              units={units}
                                              form={form}/>
                        }

                        {
                            remainingGroups?.map((item: SensorSettings, index: number) => {
                                return <DeviceSettingsForm key={`device_0005${item.name}${index}`}
                                                           form={form}
                                                           units={units}
                                                           sensorSettings={item}
                                                           deviceType={deviceType}
                                />;
                            })
                        }

                    </div>
                </div>
            </Form>
        </div>
    );
};

export default EditSensorsSettingsForm;